import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "store";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { removeCandidate } from "../../../../../store/steps/stepFiveSlice";
import { SIZES } from "../../../../../utils/enums";

const CandidateTable = () => {
  const dispatch = useDispatch();
  const handleDelete = (index: number) => {
    dispatch(removeCandidate(index));
  };
  const { candidates } = useSelector((state: RootState) => state.stepFive);

  return (
    <>
      {candidates.length > 0 && (
        <div className="mt-4">
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: {
                md: 110,
                xl: 250,
              },
            }}
          >
            <Table stickyHeader size={SIZES.sm}>
              <TableHead>
                <TableRow>
                  <TableCell className="!bg-gray-200">
                    {STATIC_STRINGS.CANDIDATE_NAME}
                  </TableCell>
                  <TableCell className="!bg-gray-200">
                    {STATIC_STRINGS.EMAIL}
                  </TableCell>
                  <TableCell className="!bg-gray-200">
                    {STATIC_STRINGS.TABLE_HEADERS.ACTIONS}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {candidates.map((candidate, index) => (
                  <TableRow key={candidate.name + index}>
                    <TableCell component="th" scope="row">
                      {candidate.name}
                    </TableCell>
                    <TableCell>{candidate.email}</TableCell>
                    <TableCell>
                      <div
                        className="cursor-pointer hover:text-neutral-dark w-fit px-1"
                        onClick={() => {
                          handleDelete(index);
                        }}
                      >
                        <DeleteForeverIcon />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </>
  );
};

export default CandidateTable;
